const searchFieldFocused = () => {
    const input = document.querySelector('.Search-field__input');
    const inputWrapper = document.querySelector('.Search-field__field-group');

    if (input && inputWrapper) {
        input.addEventListener('focus', () => {
            inputWrapper.classList.add('--Is-focused');
        });
        input.addEventListener('blur', () => {
            inputWrapper.classList.remove('--Is-focused');
        });
    }
};

export default searchFieldFocused;
